import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';

const ForgotPasswordRequest = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      const response = await fetch('https://beta.flowlogic.com/api/users/forgot-password/request/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, phone_number: '', country_code: '' }),
      });

      const result = await response.json();
      if (response.ok) {
        localStorage.setItem('forgotEmail', email);
        localStorage.setItem('resetOtp', result.data.otp);
        setMessage(`OTP sent to your email: ${email}`);
        navigate('/reset-password');
      } else {
        setError(result.message || 'Failed to send OTP. Try again.');
      }
    } catch (err) {
      setError('Something went wrong.');
    }
  };

  return (
    <div className="signMainInOuter">
      <div className="signInOuter">
        <div className="logo"><img src="/assets/Flowlogic-Logo.svg" alt="FlowLogic Icon" /></div>
        <h4>Forgot Password</h4>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="email"
              placeholder="Enter your registered email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <Button variant="success" type="submit">Request OTP</Button>
        </form>
        {message && <p style={{ color: 'green' }}>{message}</p>}
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </div>
    </div>
  );
};

export default ForgotPasswordRequest;
